import React from "react";

import { dateFilter } from "@ip-utils";

import Date from "./index";

export default function Between({ name, value = null, onChange, ...props }) {
  value = {
    end: value && value.end ? value.end : null,
    start: value && value.start ? value.start : null,
  };

  function handleChange(e) {
    let val = {
      ...value,
      [e.target.name]: e.target.value,
    };

    if (val && !val.start && !val.end) {
      val = null;
    }

    onChange({
      target: {
        name,
        value: val,
      },
    });
  }

  return (
    <React.Fragment>
      <Date
        label="Start Date"
        name="start"
        value={value.start}
        onChange={handleChange}
        {...props}
      />
      <Date
        label="End Date"
        name="end"
        value={value.end}
        onChange={handleChange}
        {...props}
      />
    </React.Fragment>
  );
}

Between.count = 2;
Between.filter = dateFilter;
